<style></style>

<template>
  <div style="display:flex; position: relative;">
    <div
      style="overflow-x: auto;"
    >
      <div class="table-container">
        <div class="SectionTable">
          <TemplateSectionRow
            v-for="(row, i) in rows"
            :key="i"
            :row="row"
          />
        </div>
      </div>

      <TemplateSectionTimeline
        :section="getSectionById('section_timeline')"
      />

      <TemplateSectionEnvironment
        :section="getSectionById('section_environment')"
      />
    </div>

  </div>
</template>

<script>

import TemplateSectionTimeline
  from '@/components/sections/TemplateSection/TemplateSectionTimeline.vue';
import TemplateSectionEnvironment
  from '@/components/sections/TemplateSection/TemplateSectionEnvironment.vue';
import TemplateSectionRow from './TemplateSection/TemplateSectionResourceTableRow.vue';
// mixins
import Mixin from '../../mixins/mixin';

export default {
  components: {
    TemplateSectionTimeline,
    TemplateSectionEnvironment,
    TemplateSectionRow,
  },
  mixins: [Mixin],
  data: () => ({}),
  props: {},
  computed: {
    rows() {
      const rows = [];
      rows.push({
        className: 'row-worksheet-header',
        content: '&nbsp;',
      }, {}, {
        className: 'row-section-header',
        content: this.translate('module_assumptions').toUpperCase(),
      }, {}, {});
      return rows;
    },
  },
  methods: {},
  mounted() {},
};
</script>
